
import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'app/store/store'
import { IProjects, IProjectsState, TError } from './types/projects-interface'

const ProjetcsState = (state: RootState): IProjectsState => state.projetcs

export const Projetcs = createSelector(
    [ProjetcsState],
    (state): IProjects[] => state.Projects,
)
export const ProjectsCount = createSelector(
    [ProjetcsState],
    (state): number => state.ProjectsCount,
)
export const LoadingProjects = createSelector(
    [ProjetcsState],
    (state): boolean => state.isLoadingProjects,
)
export const ErrorProjects = createSelector(
    [ProjetcsState],
    (state): TError => state.errorProjects,
)

export const CurrentPageProjects = createSelector(
    [ProjetcsState],
    (state): number => state.currentPage,
)

export const DownloadProjects = createSelector(
    [ProjetcsState],
    (state): boolean => state.isDownloadProjects,
)
export const ErrorDownloadProjects = createSelector(
    [ProjetcsState],
    (state): TError => state.errorDownloadProjects,
)
export const FileData = createSelector(
    [ProjetcsState],
    (state): string => state.FileData,
)
export const FileName = createSelector(
    [ProjetcsState],
    (state): string => state.FileName,
)